import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import wpImage from "../../assets/whatsapp_color_image.webp";

const handleWasap = function(e){
  e.preventDefault();
  window.open(`https://wa.me/+5491132640285`,'_blank');
}

export default function Layout({children}) {
  return (
    <div>
        <Navbar/>
        {children}

        {/*  Logo wasap */}
        <img src={wpImage}  
          alt="Whatsapp Icon" 
          className="wppIcon" 
          onClick={handleWasap}
        />

        <Footer/>
    </div>
  )
}
